


import { HiOutlineExclamation } from "react-icons/hi";
function Danger({message}) {
    return (
      <div className="text-red-600 font-medium flex items-center">
        <HiOutlineExclamation className="mr-2 text-2xl stroke-red-600 stroke-[3px]"></HiOutlineExclamation>
        <p>{message}</p>
      </div>
    );
  }

  export default Danger;